import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliTextInput, LiliTooltip, LiliToolTipColor, TooltipPosition } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '../../../../hooks/providers/ControllerWrapper';
import { LiliCheckbox, LiliCheckboxType } from '../../../../DesignSystem/LiliCheckbox/LiliCheckbox';
import Heading from '../../../../generic-components/Heading';
import { FormTypes, UpdateVendorFormFieldsMap, UpdateVendorFormProps } from '../../interfaces';
import { ExtendedUseFormReturn } from '../../../../hooks/providers/useFormHooks';
import { ReactComponent as InfoIcon } from '../../../../assets/svg/infoIconHovered.svg';

interface ICommonFields {
  formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>;
  formType: FormTypes;
  isUpdateNameRequired?: boolean;
}

export const CommonFields = ({ formMethods, formType, isUpdateNameRequired }: ICommonFields) => {
  const { t } = useTranslation();

  const dynamicBusinessNameTitle =
    formType === FormTypes.BUSINESS ? t('MANAGE_VENDOR.FORM.BUSINESS_NAME') : t('MANAGE_VENDOR.FORM.VENDOR_NAME');
  const dynamicBusinessNameTooltip =
    formType === FormTypes.BUSINESS
      ? t('MANAGE_VENDOR.FORM.BUSINESS_NAME_TOOLTIP')
      : t('MANAGE_VENDOR.FORM.VENDOR_NAME_TOOLTIP');

  return (
    <>
      <ControllerWrapper name={UpdateVendorFormFieldsMap.BUSINESS_NAME} control={formMethods?.control}>
        {({ onBlur, onChange, error, value }) => (
          <LiliTextInput
            onChange={onChange}
            value={value}
            onBlur={onBlur}
            maxLength={40}
            id={UpdateVendorFormFieldsMap.BUSINESS_NAME}
            title={dynamicBusinessNameTitle}
            showClear={false}
            errorMessage={error?.message}
            accessoryItemComponent={
              <InfoIcon
                className='z-50 absolute top-1/2 -translate-y-1/2 right-[12px] h-[20px] w-[20px]'
                data-tooltip-id='recipient-name-tooltip'
              />
            }
          />
        )}
      </ControllerWrapper>
      <LiliTooltip
        description={dynamicBusinessNameTooltip}
        targetId='recipient-name-tooltip'
        position={TooltipPosition.RIGHT_END}
        color={LiliToolTipColor.White}
      />
      {!isUpdateNameRequired && (
        <ControllerWrapper name={UpdateVendorFormFieldsMap.EMAIL} control={formMethods?.control}>
          {({ onBlur, onChange, error, value }) => (
            <LiliTextInput
              onChange={onChange}
              value={value}
              onBlur={onBlur}
              id={UpdateVendorFormFieldsMap.EMAIL}
              title={t('MANAGE_VENDOR.FORM.EMAIL_OPTIONAL')}
              errorMessage={error?.message}
            />
          )}
        </ControllerWrapper>
      )}

      {!isUpdateNameRequired && (
        <ControllerWrapper name={UpdateVendorFormFieldsMap.NOTIFY_VENDOR} control={formMethods?.control}>
          {({ onChange, error, value }) => (
            <div className='flex items-center gap-[8px] mb-[18px]'>
              <LiliCheckbox
                containerClassName='w-fit'
                type={error ? LiliCheckboxType.ERROR : LiliCheckboxType.REGULAR}
                id={UpdateVendorFormFieldsMap.NOTIFY_VENDOR}
                checked={value}
                onCheckedChange={onChange}
              />
              <Heading
                title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.NOTIFY_VENDOR')}
                className='font-metricR text-bw07'
              />
            </div>
          )}
        </ControllerWrapper>
      )}
    </>
  );
};
